import ExcelJS from 'exceljs';

export async function downloadProtocolXlsx(rows: string[][], fileName: string) {
  let rowsToUpdate = JSON.parse(JSON.stringify(rows));
  rowsToUpdate[0][1] = rowsToUpdate[0][1].slice(0, -1) + ' UTC';
  for (let i = 0; i < rowsToUpdate.length; i++) {
    let row = rowsToUpdate[i];
    if (row[0] === 'ISSUE CODES' && i < rowsToUpdate?.length - 1) {
      rowsToUpdate[i + 1][0] = 'ISSUE CODES';
      rowsToUpdate.splice(i, 1);
      break;
    }
  }
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(rows[0][0]);
  worksheet.addRows(rowsToUpdate);

  //column resize
  worksheet.getColumn(1).width = 30.22;
  worksheet.getColumn(2).width = 73.33;
  worksheet.getColumn(3).width = 130;

  //wrap text
  worksheet.eachRow((row) => {
    row.alignment = {wrapText: true};
  });
  //bold 1st row
  worksheet.getRow(1).font = {bold: true};
  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `${fileName}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();

    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  });
}
